import { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";

import * as colors from '../styles/colors'
import { useAuthState } from '../context/auth';
import { redirectLoggedUserDefault } from '../routes';

function NotFoundView() {

  const { user } = useAuthState();
  
  const [urlRedirect, setUrlRedirect] = useState('');

  useEffect(() => {
    if(user) setUrlRedirect(redirectLoggedUserDefault[user.roles])
},[user]);

  return (
    <div css={{ marginTop: '20px', height: '100%', display: 'grid', alignItems: 'center', justifyContent: 'center'}}>
      <div>
        Página no encontrada. <NavLink style={{color: colors.blue}} to={urlRedirect}>Ir a la página principal</NavLink>
      </div>
    </div>
  )
}

export default NotFoundView